import React from "react";
import {WhiteCard} from "../_components/WhiteCard";
import {ABOverlayPopover} from "../../_components/CustomOverlayTooltip";
import {TableLikeText} from "../../_components";
import {useTopicSSE} from "../../../hooks/useTopicSSE";
import {SseTopics} from "../../../context/SSEContext";

export function NetworkSection() {
    const online = useTopicSSE(SseTopics.Online)
    const net = useTopicSSE(SseTopics.Network)

    return <>
        {online && <WhiteCard className="flex-grow-1">
            <NetworkCard net={net}/>
        </WhiteCard>}
    </>
}

function NetworkCard({net}) {

    if (net)
        return <>
            <ABOverlayPopover buttonLabel="Network" headerText="Additional details">
                <div>
                    <TableLikeText titleColor="text-light" title="IPv4 address" value={net.ipv4}/>
                    <TableLikeText titleColor="text-light" title="IPv4 gateway" value={net?.gateway}/>
                    <TableLikeText titleColor="text-light" title="IPv4 broadcast" value={net?.bcast}/>
                    <TableLikeText titleColor="text-light" title="IPv4 mask" value={net?.mask}/>
                    <TableLikeText titleColor="text-light" title="DNS1" value={net?.dns1}/>
                    <TableLikeText titleColor="text-light" title="DNS2" value={net?.dns2}/>
                    <TableLikeText titleColor="text-light" title="Manufacturer" value={net?.mnf}/>
                    <TableLikeText titleColor="text-light" title="Driver" value={net?.drv}/>
                </div>
            </ABOverlayPopover>

            <TableLikeText title="IP Assignment" value={net?.dhcpc ? "DHCP" : "Manual"}/>
            <TableLikeText title="MAC" value={net?.mac.toUpperCase()}/>
            <TableLikeText title="NetBIOS" value={net?.bios}/>
            <TableLikeText title="Interface" value={net?.name}/>
        </>
    else
        return null
}
